module.exports = __webpack_public_path__ + "video/1000_HC_2023_Password_Security.efd74e67.vtt";